/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestorEligibilityFilter {
    RELEASE = 'release',
    INVITE = 'invite',
    ALLOCATION = 'allocation',
    LEAVER = 'leaver',
}
